import constants from './constants';
import { createFailure, createRequest, createSuccess } from 'ducks/helpers';

export const attachmentsRequest = createRequest(constants.attachments);
export const attachmentsSuccess = createSuccess(constants.attachments);
export const attachmentsFailure = createFailure(constants.attachments);

export const requestAttachments = attachmentsRequest;

